import React from "react";
//#region types
import { BannerFieldProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const BannerField: React.FC<BannerFieldProps> = (props) => {
  return (
    <Grid container direction="column" className={cssExports.bannerField}>
      <Grid item className={cssExports.label}>
        {props.label}
      </Grid>
      <Grid item className={cssExports.value}>
        {props.value}
      </Grid>
    </Grid>
  );
};

export default BannerField;
